import { Button, Form, Input, Space } from "antd";
import _t from "../../lang/translate";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import EnumSelect from "../form/enumSelect";
import InputNum from "../form/inputNum";
import { renderErrorMessage } from "../messages/errorMessage";

export type NewCustomEquipment = {
  code: string;
  name: string;
  category: number;
  price: number;
}

export default function AddCustomEquipment<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [form] = Form.useForm<NewCustomEquipment>();

  const handleSubmit = async (values: NewCustomEquipment) => {
    try {
      const result = values
      onSuccess(result as T);
    } catch (error) {
      renderErrorMessage(error)
    }
  };

  return (
    <Form form={form} requiredMark={false} layout="horizontal" onFinish={handleSubmit}
      initialValues={{ category: 2 }} labelAlign="left"
    >
      <h2 className="modal-title">{_t("add", "equipment")}</h2>
      <Form.Item name="code" label={_t("code")} rules={[{ required: true }]}>
        <Input autoFocus />
      </Form.Item>
      <Form.Item name="name" label={_t("name")} rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="category" label={_t("category")} rules={[{ required: true }]}>
        <EnumSelect
          placeholder={_t("category")}
          style={{ width: "100%" }}
          nameKey={["vehicle", "equipmentCategory"]}
        />
      </Form.Item>
      <Form.Item name="price" label={_t("price")} rules={[{ required: true }]}>
        <InputNum />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" type="primary">
            {_t("add")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(AddCustomEquipment);
